import { styled } from '../styled-components';

export const UiAffixContent = styled.div.attrs({ className: 'UiAffixContent' })`
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  padding: ${p => p.theme.space};
`;
